<template>
  <footer class="kurdos-footer" v-if="$route.fullPath && !$route.fullPath.includes('healthcare')">
    <div class="k-copyright-wrapper">
      <div class="k-copyright-container k-container clearfix">
        <div class="k-copyright-left k-item-pdlr" v-if="enActive">
          {{ year }} &copy; Kurdos Company | Developed by
          <a href="https://www.blackace.tech" target="_blank"> Black Ace </a>
        </div>
        <div class="k-copyright-left k-item-pdlr" v-else>
          <a href="https://www.blackace.tech" target="_blank"> Black Ace </a>
          {{ lang.footerDesc }} {{ year }}
        </div>
      </div>
    </div>
  </footer>
  <footer class="kurdos-healthcare-footer" :dir="isLangEnglish ? 'ltr' : 'rtl'" v-else>
    <div class="k-copyright-wrapper">
      <div><img src="/images/healthcare_logo.png" style="width: 140px" /> </div>
      <div class="text">
        {{ year }} &copy; Kurdos Company | Developed by
        <a href="https://www.blackace.tech" target="_blank"> Black Ace </a>
      </div>
    </div>
  </footer>

</template>

<script>
import { onMounted } from 'vue';
import { isLangEnglish } from '../utils/language_selector';
import { selectedLang } from '../utils/selected_lang';

export default {
  inject: ["lang", "language"],
   watch: {
    $route(to) {
      if (to.fullPath === '/') {
        this.$nextTick(() => {
          const footer = document.getElementsByClassName('kurdos-footer')[0];
          if (footer) {
            footer.style.opacity = '0';
          }
        });
      } else {
        this.$nextTick(() => {
          const footer = document.getElementsByClassName('kurdos-footer')[0];
          if (footer) {
            footer.style.opacity = '1';
          }
        });
      }
    }
  },
  mounted() {
    if (this.$route.fullPath && this.$route.fullPath == '/') {
      const footer = document.getElementsByClassName('kurdos-footer')[0];
      if (footer) {
        footer.style.opacity = '0';
      }
    }
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
    enActive() {
      return this.language === "en";
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif !important;
}

footer {
  position: relative;
  z-index: 1;
  bottom: 0px;
}

.kurdos-healthcare-footer {
  position: relative;
}

.kurdos-healthcare-footer .k-copyright-wrapper {
  background: linear-gradient(to right, #073762, #04233F);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px 30px;

}

.kurdos-healthcare-footer .k-copyright-wrapper {
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif !important;
}

.kurdos-healthcare-footer .k-copyright-wrapper,
.kurdos-healthcare-footer .k-copyright-wrapper .k-copyright-container .k-copyright-left a {
  color: rgb(154, 154, 154);

}

@media(max-width:768px) {
  .kurdos-healthcare-footer .k-copyright-wrapper {
    flex-direction: column;

  }

  .text {
    text-align: center;
  }
}
</style>